import { network } from 'services/network';

export const createDashboard = (params) => {
    return network.post('api/bo/createDashboard', params).then((response) => {
        return response.data;
    });
};
